module.exports = __webpack_public_path__ + "nextpage2.51afca48.png";